import './SetTopic.scss';

import React, { FC } from 'react';
import { Project } from 'models/Project';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface SetTopicProps {
  selectedProject: Project,
  onGenerateSubtopics: (params: Project) => void,
  isLoading: boolean,
  setIsLoading: (isLoading: boolean) => void,
  activeStep: number;
}

const thisStepNumber = 1;

const SetTopic: FC<SetTopicProps> = ({ selectedProject, onGenerateSubtopics, isLoading, setIsLoading, activeStep }) => {

  const handleGenerateSubtopics = async () => {
    setIsLoading(true);
    try {
      await onGenerateSubtopics(selectedProject);
    } finally {
      setIsLoading(false);
    }
  }


  return (
    <div className="SubtopicList" style={{ display: activeStep === thisStepNumber ? 'block' : 'none' }}>
      <div className="topic-input">
        <h2>Topic Authority for {selectedProject.name}</h2>
        <Form>
          <Form.Group as={Row} className="mb-3" controlId="solutionForAudience">
            <Form.Label column sm="2">
              Offering
            </Form.Label>
            <Col sm="10">
              <Form.Control plaintext readOnly value={selectedProject.solutionForAudience} />
              <Form.Text className="form-text text-muted">
                This is your primary focus for building topic authority.
              </Form.Text>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="targetAudience">
            <Form.Label column sm="2">
              Target Audience
            </Form.Label>
            <Col sm="10">
              <Form.Control plaintext readOnly value={selectedProject.targetAudience} />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="globalNegativeTerms">
            <Form.Label column sm="2">
              Topic Exclusions
            </Form.Label>
            <Col sm="10">
              <Form.Control plaintext readOnly value={selectedProject.globalNegativeTerms} />
            </Col>
          </Form.Group>
        </Form>
        <p className='form-text text-muted'>
          To edit this information, please go to <Link to='/account'>Project Settings</Link>.
        </p>
        <Button variant="primary" onClick={handleGenerateSubtopics} disabled={isLoading}>
          Generate Subtopic Graph
        </Button>
      </div>
    </div>
  );
}

export default SetTopic;
